
import LoadingShort from '../load/loadingShort';

export default function ButtonLeft({ title, funcao, disabled, load, children }) {
  const buttonDisabled = disabled || load;

  return (
    <div className="tw-flex tw-items-center tw-justify-end tw-gap-3 tw-m-6" style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 12, }}>



      <button
        onClick={funcao}
        disabled={buttonDisabled}
        type="button"

        className={
          `tw-ml-auto tw-px-5 tw-py-2 tw-rounded-lg tw-text-sm tw-font-semibold tw-text-white
          tw-bg-[#85287e] tw-transition-all tw-duration-300
          hover:tw-bg-[#6A2065] hover:tw-shadow-md hover:tw-scale-105
          ${buttonDisabled ? 'tw-opacity-50 tw-cursor-not-allowed' : 'tw-cursor-pointer'}`
        }
        style={{
          // marginLeft: 'auto',
          padding: '10px 20px',
          borderRadius: '8px',
          fontSize: '14px',
          fontWeight: 600,
          color: '#ffffff',
          backgroundColor: '#85287e',
          transition: 'all 300ms ease',
          cursor: buttonDisabled ? 'not-allowed' : 'pointer',
          opacity: buttonDisabled ? 0.5 : 1,
          border: 'none',
        }}
      >
        {load ? <LoadingShort /> : title}
      </button>

      {children}
    </div>
  );
}

